"use client"

import { BluetoothOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BluetoothOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BluetoothOffIcon = component(Icon)({ as: BluetoothOff })
